
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              disableBtn(this.submitButton);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", async () => {
  const addToCartBtn = document.querySelector('form[action="/cart/add"] button[type="submit"]');
  if (!addToCartBtn) return;

  const variantId = parseInt(document.querySelector('[name="id"]').value);

  // Sync button on page load
  await syncButtonState(variantId, addToCartBtn);

  // Intercept form submit to prevent duplicates
  const productForm = document.querySelector('form[action="/cart/add"]');
  productForm.addEventListener("submit", async (e) => {
    if (await productAlreadyInCart(variantId)) {
      e.preventDefault();
      disableBtn(addToCartBtn);
    }
  });

  // Subscribe to cart updates (add/remove)
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    let cartItems = [];

    if (Array.isArray(event.cartData?.items)) {
      // Full cart (from drawer)
      cartItems = event.cartData.items;
    } else if (event.cartData?.variant_id) {
      // Single item (from product form)
      cartItems = [event.cartData];
    } else {
      // Fallback: fetch full cart
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          toggleButtonState(cart.items || []);
        });
      return;
    }

    toggleButtonState(cartItems);

    function toggleButtonState(items) {
      const exists = items.some(item => item.variant_id === variantId);
      if (exists) {
        disableBtn(addToCartBtn);
      } else {
        enableBtn(addToCartBtn);
      }
    }
  });
});

// Used on initial page load
async function syncButtonState(variantId, btn) {
  const cart = await fetch('/cart.js').then(r => r.json());
  const exists = cart.items.some(item => item.variant_id === variantId);
  console.log(exists);
  exists ? disableBtn(btn) : enableBtn(btn);
}

async function productAlreadyInCart(variantId) {
  const cart = await fetch('/cart.js').then(r => r.json());
  return cart.items.some(item => item.variant_id === variantId);
}

// Disable button
function disableBtn(btn) {
  const label = btn.querySelector('span');
  if (label) label.textContent = "Already in Cart";
  btn.disabled = true;
  btn.style.cursor = "not-allowed";
  btn.style.opacity = "0.6";
}

// Enable button
function enableBtn(btn) {
  const label = btn.querySelector('span');
  if (label) label.textContent = "Add to Cart";
  btn.disabled = false;
  btn.style.cursor = "pointer";
  btn.style.opacity = "1";
}
